import { Injectable } from "@angular/core";
import { EncuestaDTO, PreguntaDTO } from "@DTOS";
import { ModalPruebaInternaComponent } from "@shared/components";
import { ModalService } from "@shared/services";
import "@extensiones";
import { CuestionariosUtils } from "../Cuestionarios.utils";

@Injectable({
    providedIn: "root"
})
export class CuestionariosUtilsImpl implements CuestionariosUtils {
    constructor(private modalService: ModalService) {}

    public obtenerPreguntasParseadas(encuesta: EncuestaDTO): PreguntaDTO[] {
        const preguntasMatriz: PreguntaDTO[] = [];

        encuesta.preguntas?.forEach(pregunta => {
            if (pregunta.padre) {
                const preguntaPadre =
                    preguntasMatriz.find(preguntaMatriz => preguntaMatriz.id === pregunta.padre) ?? new PreguntaDTO();

                if (!preguntaPadre.preguntas) {
                    preguntaPadre.preguntas = [];
                }

                preguntaPadre.preguntas.push(pregunta);

                return;
            }

            if (!pregunta.esMatriz()) {
                return;
            }

            preguntasMatriz.push(pregunta);
        });

        return encuesta.preguntas?.filter(pregunta => !pregunta.padre) ?? [];
    }

    public async enviarPruebaInternaAsync(): Promise<any> {
        const modalRef = this.modalService.open(ModalPruebaInternaComponent, { centered: true });

        return await modalRef.result.catch(() => {});
    }
}
